import { Navigation } from '@sketch-note/design-system/src/shared/site-settings';
import { isSSR } from '@sketch-note/design-system/src/shared/utils';
import axios from 'axios';
import Config from 'config';
import config from 'config';
import { EventSourcePolyfill } from 'event-source-polyfill';
import merge from 'lodash/merge';
import Router from 'next/router';
import { signOut } from 'next-auth/client';
import { useAuth } from 'src/shared/hooks/use-auth';
import { authPages } from 'src/shared/utils';

if (config.localServer) {
  process.env.NODE_TLS_REJECT_UNAUTHORIZED = config.localServer;
}
export const API = axios.create({ baseURL: Config.apiBase });

API.defaults.headers['Content-Type'] = 'application/json';
API.defaults.headers.Accept = 'application/json';

API.interceptors.request.use((config) => {
  const accessToken = useAuth.getState().accessToken;
  const orgId = useAuth.getState().orgId;
  const isPublicFile = useAuth.getState().isPublicFile;
  const publicPassword = useAuth.getState().publicPassword;

  if (!isSSR()) {
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    if (orgId) {
      config.headers.Org = orgId;
    }

    if (isPublicFile) {
      config.headers.isPublicFile = isPublicFile;
      if (publicPassword) {
        config.headers.pwd = publicPassword;
      }
    }
  }

  return config;
});

API.interceptors.response.use(
  async (response) => {
    if (
      !isSSR() &&
      response?.data &&
      response.data.success === false &&
      response.data.message === 'Invalid Token!' &&
      !authPages.includes(Router.pathname)
    ) {
      await signOut();
      location.href = Navigation.Signin.href;
    }
    return response;
  },
  async (error) => {
    if (!isSSR() && error?.response?.status === 401) {
      await signOut();
      location.href = Navigation.Signin.href;
    }
    throw error;
  }
);

export const EventSourceAPI = (url: string, config?: any) => {
  const accessToken = useAuth.getState().accessToken;
  const defaultConfig = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return new EventSourcePolyfill(url, merge(defaultConfig, config));
};
